import React from 'react';
import { Provider } from 'react-redux';
import { Store } from "redux";
import RouterWrapper from './RouterWrapper';
import ScrollToTop from '../Utils/ScrollToTop/ScrollToTop';
import ResizeOnUpdate from '../Utils/ResizeOnUpdate/ResizeOnUpdate';
import GeoHierarchyPage from "../GeoHierarchyPage/GeoHierarchyPage";

type AppProviderPropTypes = {
  store: Store;
};

const AppProvider = ({ store }: AppProviderPropTypes): JSX.Element => (
  <Provider store={store}>
    <RouterWrapper>
      <ScrollToTop>
        <ResizeOnUpdate>
          <GeoHierarchyPage />
        </ResizeOnUpdate>
      </ScrollToTop>
    </RouterWrapper>
  </Provider>
);

export default AppProvider;
